
const SearchIconSmall = ({ color = "#667085" }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
            <path d="M12.2504 12.7501L9.71875 10.2184" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6.41667 11.5833C8.994 11.5833 11.0833 9.494 11.0833 6.91667C11.0833 4.33934 8.994 2.25 6.41667 2.25C3.83934 2.25 1.75 4.33934 1.75 6.91667C1.75 9.494 3.83934 11.5833 6.41667 11.5833Z" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default SearchIconSmall